import React from "react";
import img1 from "../../../Assets/Home/BlogImg1.png";
import { useNavigate } from "react-router-dom";
const posts = [
  {
    id: 1,
    type: "featured",
    image: img1,
    title: "Ensuring Mine Safety: Modern Practices to Protect Workers",
    excerpt:
      "Discover how advanced safety protocols, real-time monitoring, and training programs are reducing risks and improving worker safety in mining operations.",
    date: "05 Feb, 2026",
  },
  {
    id: 2,
    type: "small",
    tag: "Safety",
    tagColor: "#e8341c",
    title: "Top 10 Mine Safety Measures Every Site Must Follow",
    date: "08 Feb, 2026",
  },
  {
    id: 3,
    type: "small",
    tag: "Environment",
    tagColor: "#e8341c",
    title: "Sustainable Mining: Protecting Nature While Extracting Resources",
    date: "12 Feb, 2026",
  },
  {
    id: 4,
    type: "small",
    tag: "Protection",
    tagColor: "#e8341c",
    title: "How Dust Control Systems Improve Air Quality in Mines",
    date: "16 Feb, 2026",
  },
  {
    id: 5,
    type: "small",
    tag: "Responsibility",
    tagColor: "#e8341c",
    title: "Environmental Impact Assessments in Mining Projects",
    date: "20 Feb, 2026",
  },
];

const ViewMore = ({ date }) => (
  <div className="flex items-center gap-2 sm:gap-3 mt-2 sm:mt-3 flex-wrap">
    <span
      className="text-[10px] sm:text-xs font-black tracking-widest uppercase text-gray-900 border-b-2 border-gray-900 pb-0.5 cursor-pointer hover:text-[#e8341c] hover:border-[#e8341c] transition-colors duration-200 whitespace-nowrap"
      style={{ letterSpacing: "0.12em" }}
    >
      VIEW MORE
    </span>
    <span className="text-gray-400 text-[10px] sm:text-xs">{date}</span>
  </div>
);

export default function OurBlog() {
  return (
    <div
      id="blog"
      className="w-full py-10 sm:py-12 md:py-14 px-4 sm:px-6 md:px-8 bg-[#f5f0e8]"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header row */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-6 sm:mb-8 gap-4 sm:gap-0">
          <div>
            <span className="text-[10px] sm:text-xs md:text-sm font-krona font-bold tracking-[0.22em] text-gray-700 uppercase border-b-2 border-[#e8341c] pb-1 inline-block">
              BLOG & ARTICLES
            </span>
            <h2
              className="mt-2 sm:mt-3 text-gray-900 font-extrabold font-krona"
              style={{
                fontSize: "clamp(24px, 5vw, 45px)",
                letterSpacing: "-0.02em",
                lineHeight: 1.2,
              }}
            >
              Our Recent Post
            </h2>
          </div>
          <button
            className="bg-gray-900 text-white text-[10px] sm:text-xs font-bold tracking-[0.16em] uppercase px-4 sm:px-5 py-2.5 sm:py-3 rounded hover:bg-[#e8341c] transition-colors duration-200 w-full sm:w-auto text-center"
            style={{ letterSpacing: "0.16em" }}
          >
            SEE MORE ARTICLES
          </button>
        </div>

        {/* Grid - Responsive layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5 lg:gap-6">
          {/* Featured large card - Full width on mobile, spans 2 rows on desktop */}
          <div
            className="relative rounded-xl overflow-hidden flex flex-col justify-end cursor-pointer group md:row-span-2 border border-gray-700 w-full"
            style={{
              minHeight: "clamp(350px, 50vw, 420px)",
              background: "#1a1008",
            }}
          >
            {/* Image */}
            <img
              src={posts[0].image}
              alt={posts[0].title}
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            {/* Content Overlay - Improved for mobile */}
            <div className="relative z-10 p-4 sm:p-5 md:p-6 bg-gradient-to-t from-black/80 via-black/50 to-transparent mt-auto">
              <h3 className="text-white font-extrabold text-base sm:text-lg md:text-xl leading-snug mb-1 sm:mb-2 line-clamp-2">
                {posts[0].title}
              </h3>
              <p className="text-gray-200 text-xs sm:text-sm leading-relaxed mb-1 sm:mb-2 line-clamp-2">
                {posts[0].excerpt}
              </p>
              <div className="flex items-center gap-2 sm:gap-3 mt-1 sm:mt-2">
                <span className="text-white text-[10px] sm:text-xs font-black tracking-widest uppercase border-b-2 border-white pb-0.5 cursor-pointer hover:text-[#e8341c] hover:border-[#e8341c] transition-colors duration-200">
                  VIEW MORE
                </span>
                <span className="text-gray-300 text-[10px] sm:text-xs">
                  {posts[0].date}
                </span>
              </div>
            </div>
          </div>

          {/* Small cards - 2 column on mobile, 1 column on tablet, 2 column on desktop */}
          <div className="grid grid-cols-2 md:grid-cols-1 lg:grid-cols-2 col-span-1 md:col-span-2 gap-4 sm:gap-5 lg:gap-6">
            {posts.slice(1).map((post) => (
              <div
                key={post.id}
                className="rounded-xl p-3 sm:p-4 md:p-5 flex flex-col justify-between cursor-pointer hover:shadow-md transition-shadow duration-200 border border-gray-800 bg-[#F9F4F0]"
                style={{
                  minHeight: "clamp(150px, 20vw, 175px)",
                }}
              >
                {/* Tag and Title */}
                <div>
                  <span
                    className="inline-block text-white text-[8px] sm:text-[10px] font-bold tracking-wider uppercase px-2 sm:px-3 py-0.5 sm:py-1 rounded mb-2 sm:mb-3"
                    style={{ background: post.tagColor }}
                  >
                    {post.tag}
                  </span>
                  <h4 className="text-gray-900 font-extrabold text-xs sm:text-sm md:text-base leading-snug line-clamp-2">
                    {post.title}
                  </h4>
                </div>
                <ViewMore date={post.date} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
